<template>
  <div id="game-wrapper" :class="{start: bStartScreen}" @click="bStartScreen = false" @touchstart.self.prevent="bStartScreen = false">
    <img id="object" src="../src/assets/object.png" alt="" />
    <img id="title" src="../src/assets/title.jpg" alt="" />
    <div id="question">
      <h1 v-html="question.text">
      </h1>
      <ul>
        <li v-for="answer in question.answers" :key="answer.id" :data-answer-id="answer.id" @click="onAnswerClick(answer.id)" @touchstart.self.prevent="onAnswerClick(answer.id)" :class="{current: (answer.id == selectedAnswerId)}">
          <span>{{ answer.text }}</span>
        </li>
      </ul>
    </div>
    <div>
      <div :class="{popup: true, show: (answer.id == selectedAnswerId)}" v-for="answer in question.answers" :key="answer.id" @click="selectedAnswerId = 0" @touchstart.self.prevent="selectedAnswerId = 0" v-html="answer.popup"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Multiple-Choice',
  data () {
    return {
      bStartScreen: true,
      selectedAnswerId: 0,
      question: {
        text: '<span class="small">Les saints sont souvent les saints patrons d’un lieu, d’une profession ou d’une chose en particulier. <br>Si on leur adresse une prière, ils peuvent nous aider et nous protéger. </span> <br><br><span>Quand puis-je faire une requête à saint Sébastien ?</span>',
        answers: [
          {
            id: 1,
            text: 'Lorsque tu as un long trajet en voiture à faire et que tu veux arriver sain et sauf.',
            popup: '<h2>Là, je ne peux malheureusement pas t’aider</h2> <p><img src="img/sebastian.jpg" >– mais saint Christophe, oui.</p>'
          },
          {
            id: 2,
            text: 'Lorsque de nombreuses personnes sont malades et veulent être guéries.',
            popup: '<h2>Exact ! </h2> <p><img src="img/sebastian.jpg" >Autrefois, lorsqu’au Moyen Âge, de nombreuses personnes étaient atteintes de la peste, elles m’ont invoqué pour que je leur vienne en aide.</p>'
          },
          {
            id: 3,
            text: 'Quand il pleut et que tu voudrais que le soleil brille.',
            popup: '<h2>Là, je ne peux malheureusement pas t’aider </h2> <p><img src="img/sebastian.jpg" >– mais les saints Jean et Paul, oui.</p>'
          }
        ]
      }
    }
  },
  methods: {
    onAnswerClick (id) {
      console.log('onAnswerClick()', id)
      this.selectedAnswerId = id
    }
  }
}
</script>
